import { SR_API_ACTION_LOAD_FUZZY_SEARCH_LISTINGS } from 'api/actionTypes';

export default async function loadFuzzySearchListings({ state, apiClient }, payload) {
  const { searchTerm } = payload;

  if (!searchTerm) {
    return;
  }

  state.set(['fuzzySearchListings', 'searchTerm'], searchTerm);

  await apiClient.postWithState({
    action: SR_API_ACTION_LOAD_FUZZY_SEARCH_LISTINGS,
    state: state,
    payload: {
      searchTerm,
    },
    onSuccess(listings) {
      if (state.get(['fuzzySearchListings', 'searchTerm']) === searchTerm) {
        state.set(['fuzzySearchListings', 'results'], listings);
        state.set(['fuzzySearchListings', 'latestSearchTermRetrieved'], searchTerm);
      }
    },
  });
}
